<template>
  <div class="whole-page">
    <input type="file" id="file"></input>
    <el-button @click="createDB('test',2)" size="mini" style="width: 5vw"></el-button>
    <el-button @click="insert('test','table','id:123')" size="mini" style="width: 5vw">123</el-button>
    <el-button @click="getData" style="width: 10vw">2222</el-button>
  </div>
</template>
<script>
export default {
  components: {

  },
  data () {
    return {
      indexDB:''
    }
  },
  created () {
      let indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
      if( !indexedDB ){
        alert('当前不支持 indexedDB 数据库');
        throw Error('当前不支持 indexed 数据库');
      }
      else {
        this.indexDB=indexedDB
      }
  },
  mounted () {
    let form=new FormData()

  },
  methods:{
    createDB(dbName, version) {

      let request = this.indexDB.open(dbName, version);
      /**
       * request 并不会返回一个DB对象的句柄，我们得到的是一个IDBOpenDBRequest对象
       * 而我们期望得到的DB对象在其result属性中
       * 除了 result，IDBOpenDBRequest 接口定义了几个重要属性
       * onerror:请求失败的回调函数句柄
       * onsuccess:请求成功的回调函数句柄
       * onupgradeneeded:请求数据库版本变化句柄
       * 第一次打开数据库，会先触发 onupgradeneeded 事件，然后触发success事件。
       */
      console.log(request);
      // 请求数据库失败的回调函数
      request.onerror = function(err) {
        console.log(JSON.stringify(err));
        console.log('打开数据库失败,错误信息为:' + err.target.message);
      }
      // 请求数据库成功的回调函数
      request.onsuccess = function(success) {
        console.log(JSON.stringify(success));
        console.log('打开数据库成功:' + success.target.result);
        let db = success.target.result;
        // let objectStore=db.createObjectStore("table1", {keyPath: "id",autoIncrement: true})
        // if (!db.objectStoreNames.contains('table1')) {
        //   objectStore = db.createObjectStore('table1', { keyPath: 'id' });
        // }
      }
      // 数据库版本更新
      request.onupgradeneeded = function(event) {
        console.log(JSON.stringify(event));
        console.log('数据库版本有变化...');
        let db = event.target.result;
        // 判断对象储存空间名称是否存在
        if (!db.objectStoreNames.contains('table')) {
          //创建信息对象存储空间;指定keyPath选项为Id（即主键为Id）
          let objectStore = db.createObjectStore('table', {
            keyPath: 'id',
            autoIncrement: true
          });
          objectStore.createIndex('name', 'name', { unique: false });
          objectStore.createIndex('email', 'email', { unique: true });
        }
      }
    },
    // 新增数据
    // 数据库名称,对象仓库（表名）,传入的参数
    insert(dbName, objectStoreName, argument) {
        // 打开数据库
      let uint8Array = new Uint8Array( 65535 );
      uint8Array[0]=254
      let request = this.indexDB.open(dbName);
      request.onsuccess=function (event){
        let db=event.target.result
        let req=db.transaction(['table'], 'readwrite')
          .objectStore('table')
          .add({ id: 2, name: '张1213', age: 24, email: uint8Array });
        req.onerror=ev => {
          console.log(ev)
        }
      }

    },
    getData(){
      let request=this.indexDB.open('test')
      request.onsuccess=function (event){
        let db=event.target.result
        let transaction = db.transaction(['table']);
        let objectStore = transaction.objectStore('table');
        let  getRequest = objectStore.get(1);
        getRequest.onsuccess=function (event){
          console.log(getRequest.result)
        }
      }
    }
  }
}
</script>

<style scoped>
.whole-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.Card {
  background-color: transparent;
  border: none;
}

@media only screen and (min-width: 1100px) {
  .flex-box {
    margin-top: 10rem;
    width: 100vw;
    height: 60vh;
    display: flex;
    flex-direction: row-reverse;
  }

  .flex-cell {
    margin-right: 30rem;
    width: 20vw;
    height: 50vh;
  }

}

@media only screen and (max-width: 600px) {
  .flex-box {
    margin-top: 10vh;
    width: 100vw;
    height: 50vh;
    display: flex;
    flex-direction: row-reverse;
  }

  .flex-cell {
    width: 100vw;
    height: 50vh;
  }
}

.shortcut {
  position: absolute;
  right: 3vw;
  top: 60vh;
  height: 20vh;
  width: 4vw;
}
</style>
